// extracted by mini-css-extract-plugin
module.exports = {"paymentWidget":"NewPaymentCertificatePage_paymentWidget__-1-5q"};